var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.713 5.43904L17.728 5.46404C17.7883 5.56344 17.8162 5.67908 17.808 5.79504V5.84504V18.436C17.7943 19.2012 17.1642 19.8112 16.399 19.8H1.409C0.642998 19.8112 0.0126045 19.2 3.33025e-08 18.434V5.89104C-3.0781e-05 5.77447 0.0213226 5.65889 0.0630001 5.55004C0.0763577 5.50238 0.0958545 5.45666 0.121 5.41404L3.009 0.558036C3.22104 0.209148 3.60074 -0.00272799 4.009 3.55859e-05H13.796C14.2039 -0.00315138 14.5835 0.207914 14.796 0.556036L17.641 5.31804C17.668 5.35649 17.6921 5.39694 17.713 5.43904ZM13.776 1.16404H9.528L9.524 4.91004H16.014L13.776 1.16404ZM4.041 1.16404H8.33V4.90704H1.807L4.041 1.16404ZM16.201 18.567C16.314 18.5687 16.4077 18.4799 16.412 18.367V6.00003H1V18.367C1.00433 18.4799 1.09802 18.5687 1.211 18.567H16.201Z",
    fill: "#434343"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.9fc00cbc0c81ba2b0dac9262978fe1a3.svg";
export { ForwardRef as ReactComponent };